import React from 'react';
import moment from 'moment-timezone';
import { Typography, List, Card } from 'antd';
import AutoSizeTitle from '../components/autoSizeTitle/AutoSizeTitle';

const { Title, Text } = Typography;

const PageWelcome2 = ({ selectedEvaluation, totalResults, individualResults, pageNumber }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <div className='welcome-page-text'>
                        Toma una perspectiva equilibrada. La retroalimentación directa es un don
                        inapreciable. No malgastes tiempo adivinando quién dio bajas calificaciones o
                        mostrando hostilidad hacia las personas que respondieron. Dales las gracias por
                        tomarse el tiempo de darte retroalimentación, luego usa los datos en forma
                        equilibrada y efectiva para mejorar tus habilidades de liderazgo.
                        <br /><br />
                        Escuchar y no actuar es como no haber escuchado, aprender y no aplicar es como
                        no haber aprendido. A partir del taller vas a tener la oportunidad de utilizar
                        herramientas con tus equipos de trabajo para potencializar tu liderazgo y tus
                        resultados, aprovecha esta oportunidad para decidir los cambios con los que te
                        comprometerás.
                        <br /><br />
                        Este informe presenta los resultados de tu evaluación de liderazgo estructurados en 6 secciones clave. Estas secciones te mostrarán la percepción de los demás sobre tu desempeño en relación con los 5 atributos fundamentales de nuestra Cultura HWI y un ítem adicional enfocado en el liderazgo que deseamos impulsar en la organización. Los atributos que se evaluaron son:
                        <ul>
                            <li>Creemos en nuestro Talento HWI</li>
                            <li>Actuamos con responsabilidad y conciencia para las futuras generaciones</li>
                            <li>En HWI la seguridad es lo primero</li>
                            <li>Todo lo que hacemos tiene nuestro sello de excelencia Inspirar Confianza</li>
                            <li>Juntos nos retamos y lo hacemos en grande</li>
                        </ul>
                        Recuerda que la información entregada en este reporte es totalmente
                        confidencial, que debe ser usada para tu crecimiento personal y que sólo de ti
                        depende que gracias a estos resultados puedas crear con el acompañamiento de
                        Mentoring Consultores, un plan de acción que te lleve a potencializar tu liderazgo.
                        <br /><br />
                        <br /><br />
                        <br /><br />
                        <div className='welcome-page-signature-name'>
                            EQUIPO MENTORING CONSULTORES
                        </div>
                    </div>
                </div>
                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageWelcome2;
